<template>
    <div class="header">
        <div v-if="name">
            <div v-if="topOnly">
                <!-- 只显示右上角 -->
                <div class="current current1">
                    <span @click="openPop">当前登录：{{name}}</span>
                    <div class="switch" @click="openPop"></div>
                </div>
            </div>
            <div v-else>
                <div class="banner">
                    <div class="current">
                        <span @click="openPop">当前登录：{{name}}</span>
                        <div class="switch" @click="openPop"></div>
                    </div>
                    <div class="img">
                        <img :src="`https://cdn.09game.com/resources/item/dj_${head_id}_200.png`" alt v-if="head_id && head_id>1000" />
                        <img :src="`https://cdn.09game.com/resources/head/head_${head_id}_80.png`" alt v-else />
                    </div>
                </div>
                <div class="my-name">{{name}}</div>
                <div class="lv" v-if="lv!==undefined">{{`Lv.${lv}`}}</div>
                <base-divider class="top-divider" v-else></base-divider>
            </div>

            <el-dialog title :visible.sync="pop_show" class="switch-pop" v-if="pop_show" :show-close= 'false' :close-on-click-modal="false">
                <!-- <div class="close" @click="closePop()"></div> -->
                <div class="title">请选择需要登录的昵称</div>
                <base-divider></base-divider>
                <ul class="name-ul" v-if="account_list.length>0">
                    <li class="name-li" v-for="(item, index) in account_list" :key="index">
                        <div class="img" @click="switch_account(item.user_id)">
                            <img :src="`https://cdn.09game.com/resources/item/dj_${item.avatar}_200.png`" alt v-if="item.avatar && item.avatar>1000" />
                            <img :src="`https://cdn.09game.com/resources/head/head_${item.avatar}_80.png`" alt v-else />
                        </div>
                        <div class="info">
                            <img :src="require(`@/assets/img/level/LV${item.vip_level}.png`)" alt />
                            <div class="name">{{item.user_name}}</div>
                        </div>
                    </li>
                </ul>
                <base-divider></base-divider>
                <div class="refresh">
                    <p>
                        可解除微信与当前账号的绑定
                        <span @click="refresh">立即解绑</span>
                    </p>
                </div>
            </el-dialog>
        </div>
        <div v-else>
            <div class="banner">
                <div class="img">
                    <img src="@/assets/img/logo.png" alt class="img-logo" />
                </div>
            </div>
            <div class="my-name name-df">09电竞平台</div>
            <base-divider class="top-divider"></base-divider>
        </div>
    </div>
</template>
<script>
export default {
    name: 'base-header',
    props: {
        head_id: {
            //需要默认值
            require: false,
            default: 0,
        },
        name: {
            require: false,
            default: '',
        },
        topOnly: {
            require: false,
        },
        lv: {
            require: false,
        },
        account_list: {
            require: false,
            default: () => [],
        },
    },
    created() {
        this.val = this.name
        //  console.log(this.lv);
        this.openPop();
        // console.log(this.$router.currentRoute.query);
        //  this.$router.push({ path: '/auth_page', query: { fromPage: this.$router.currentRoute.query.fromPage } })
    },
    data() {
        return {
            val: '',
            pop_show: false,
            timer: null,
            btn_lock: false,
        }
    },
    methods: {
        // 切换账号
        switch_account(user_id) {
            if(this.$storage.getOpenId() == null){
                this.$message.error('数据失效，请清空微信缓存重试！')
                return false
            }
            if(this.btn_lock) { return false }
            let token = this.$storage.getToken()
            if (token.split('-')[0] == user_id) {
                this.$message.error('不能切换至当前账号')
                return false
            }
            this.btn_lock = true;
            this.$http.setLoginByWx(token, user_id, this.$storage.getOpenId()).then((res) => {
                if (res.code == 0) {
                    this.btn_lock = false;
                    this.$message.success('切换成功')
                    this.closePop()
                    this.$storage.setAuth(res.token)
                    this.$storage.setToken(res.token)
                    let fromPage = this.$router.currentRoute.query.fromPage ? this.$router.currentRoute.query.fromPage: '';
                    if(fromPage){
                        window.location.replace(this.$common.setUrlQuery({url: decodeURIComponent(fromPage), query:{token: res.token}}));
                        // window.location.replace(decodeURIComponent(fromPage) + '?token=' + (res ? res.token : null));
                    }
                } else {
                    this.btn_lock = false;
                    this.$message.error(res.err ? res.err : '切换失败')
                }
            })
        },
        // 刷新绑定状态
        refresh() {
            if (this.timer) {
                return false
            }
            if(this.$storage.getOpenId() == null){
                this.$message.error('数据失效，请清空微信缓存重试！')
                return false
            }
            this.$http.unlockWechat(this.$storage.getToken(), this.$storage.getOpenId()).then((res) => {
                if (res.code == 0 || res.code == 2) {
                    //微信已解绑
                    localStorage.clear()
                    let fromPage = this.$router.currentRoute.query.fromPage ? this.$router.currentRoute.query.fromPage: '';
                    this.$router.push({ path: '/auth_page', query: { fromPage: fromPage } })

                } else {
                    this.$message.error(res.msg ? res.msg : res.error ? res.error : '数据有误，请清空微信缓存重试！')
                    clearTimeout(this.timer)
                    this.timer = setTimeout(() => {
                        clearTimeout(this.timer)
                        this.timer = null
                    }, 3000)
                }
            })
        },
        openPop() {
            this.pop_show = true
        },
        closePop() {
            this.pop_show = false
        },

        // emitter: function (user_id) {
        //     console.log(user_id);
        //     this.$emit('click', user_id)
        // },
    },
}
</script>
<style  lang="scss">
.switch-pop {
    .el-dialog {
        width: 100%;
        padding: 0;
        margin: 0;
        margin-top: 0 !important;
        background: transparent !important;
        border-radius: 0;
        box-shadow: none !important;
        -webkit-box-shadow: none !important;

        .el-form {
            padding-right: 80px;
        }

        .el-dialog__header {
            padding: 0;
            margin: 0;
            // display: none;
            .el-dialog__title {
                font-size: 16px;
            }
            .el-dialog__headerbtn .el-dialog__close {
                font-size: 16px !important;
            }
        }
        .el-dialog__body {
            padding: 0;
            margin: 0;
            box-shadow: none;
            -webkit-box-shadow: none;
        }

        .el-dialog__footer {
            padding: 0;
            margin: 0;
        }
    }
}
</style>
<style lang="scss" scoped>
.header {
    // position: relative;
    // margin-bottom: .45rem;
    .current {
        width: 97%;
        height: 0.24rem;
        line-height: 0.24rem;
        text-align: right;
        padding-top: 0.23rem;
        color: #ffffff;
        font-size: 0.24rem;
        .switch {
            width: 0.24rem;
            height: 0.24rem;
            background: url(~@/assets/img/switch.png) 0 0 no-repeat;
            background-size: contain;
            display: inline-block;
            vertical-align: middle;
        }

        &.current1 {
            text-shadow: 0.01rem 0.01rem 0 #000000, -0.01rem -0.01rem 0 #000000, -0.01rem 0.01rem 0 #000000, 0.01rem -0.01rem 0 #000000;
        }
    }

    .banner {
        width: 100%;
        height: 2.01rem;
        background: url(~@/assets/img/top.png) 0 0 no-repeat;
        position: relative;
        background-size: cover;
        background-position: center bottom;

        .img {
            position: absolute;
            top: 0.98rem;
            left: 50%;
            transform: translateX(-50%);
            width: 1.9rem;
            height: 1.9rem;
            background: url(~@/assets/img/head-bg.png) 0 0 no-repeat;
            background-size: cover;
            img {
                width: 1.6rem;
                height: 1.6rem;
                border-radius: 50%;
                display: block;
                margin: 0.15rem;
                &.img-logo {
                    border-radius: 0;
                }
            }
        }
    }
    .my-name {
        width: 100%;
        font-size: 0.46rem;
        text-align: center;
        height: 0.45rem;
        line-height: 0.45rem;
        color: #212121;
        margin-top: 0.96rem;
        &.name-df {
            font-size: 0.5rem;
            color: #c39b5e;
            font-weight: bold;
        }
    }
    .lv {
        width: 100%;
        text-align: center;
        height: 0.21rem;
        line-height: 0.21rem;
        color: #6f6f6f;
        font-size: 0.26rem;
        margin-top: 0.16rem;
    }
    .top-divider {
        margin: 0.33rem 0;
    }
    .switch-pop {
        width: 6.24rem;
        height: 8.24rem;
        background: #ffffff;
        border-radius: 0.3rem;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .close {
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            width: 0.56rem;
            height: 0.56rem;
            background: url(~@/assets/img/close.png) 0 0 no-repeat;
            background-size: 100% auto;
            &:hover {
                cursor: pointer;
                background-position-y: -0.56rem;
            }
        }
        .title {
            width: 100%;
            font-size: 0.4rem;
            text-align: center;
            height: 1.2rem;
            font-weight: bold;
            line-height: 1.25rem;
            color: #c39b5e;
        }
        .name-ul {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
            min-height: 5.5rem;
            margin-bottom: 0.5rem;
            .name-li {
                list-style: none;
                width: 2rem;
                margin: 0.35rem 0.34rem 0 0.34rem;
                .img {
                    width: 1.9rem;
                    height: 1.9rem;
                    background: url(~@/assets/img/head-bg.png) 0 0 no-repeat;
                    background-size: cover;
                    margin: 0 auto;
                    padding-top: 0.15rem;
                    img {
                        width: 1.6rem;
                        height: 1.6rem;
                        border-radius: 50%;
                        display: block;
                        margin: 0 0.15rem 0.15rem 0.15rem;
                    }
                }

                .info {
                    width: 100%;
                    height: 0.34rem;
                    line-height: 0.34rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 0.18rem;
                    img {
                        width: 0.34rem;
                        height: 0.34rem;
                        margin-right: 0.09rem;
                        img {
                            width: 0.34rem;
                            height: 0.34rem;
                            display: block;
                        }
                    }
                    .name {
                        color: #2e2e2e;
                        font-size: 0.28rem;
                        font-weight: bold;
                        height: 0.34rem;
                        line-height: 0.34rem;
                    }
                }
            }
        }

        .refresh {
            width: 96%;
            margin: 0 auto;
            height: 0.6rem;
            p {
                width: 100%;
                font-size: 0.26rem;
                text-align: center;
                height: 0.6rem;
                line-height: 0.6rem;
                color: #c39b5e;
                span {
                    display: inline-block;
                    color: #2f92eb;
                    text-decoration: underline;
                    padding-left: .15rem;
                    :hover {
                        cursor: pointer;
                        color: #00427e;
                    }
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/BaseHeroHeader.vue